import { Utilities } from 'src/app/services/utilities';
import { BooleanControl } from './BooleanControl';
import { AbstractControl, Validators } from '@angular/forms';



export class NullableBooleanControl extends BooleanControl {
    getTypes() {
        return [
            // { label: 'None', value: null, icon: null },
            { label: 'Yes', value: true, icon: 'fal fa-check' },
            { label: 'No', value: false, icon: 'fal fa-times' },
        ];
    }

    getDisplayValue(item: any): any {
        let tempResult: any;
        if (item) {
            const wrapperValue = item[Utilities.getVariableCaseInsensitive(item, this.variable.name)];
            const variableName = Utilities.getVariableCaseInsensitive(item, this.variable.name);
            const propertyName = Utilities.getVariableCaseInsensitive(item[variableName], this.variable.displayMetadata.templateData.keyField);

            tempResult = wrapperValue;
            if (wrapperValue && propertyName) {
                tempResult = wrapperValue[propertyName];
            }

        } else {
            tempResult = this.variable.value;
        }

        if (tempResult === true) {
            return 'Yes';
        } else if (tempResult === false) {
            return 'No';
        } else {
            return 'N/A';
        }
    }
    setValidators(formControl: AbstractControl) {

        const validators = this.variable.displayMetadata.templateData.validators?.map(element => {

            let type = <string> element.typeId;
            if (type.includes("RequiredAttribute"))
            {
                return Validators.required;
            }
        });

        formControl.setValidators(Validators.compose(validators));
    }
}
